import * as yup from "yup";
import { ErrorMessages } from "components/Form";

export const makeGooglePlaceInputValidation = (streetName, validations) => {
  const required = validations?.required || ErrorMessages.Required;
  return yup
    .string()
    .when(streetName, (street, schema) => (street ? schema : schema.required(required)));
};
